import { render } from "./TeacherLayout.vue?vue&type=template&id=44b145b2&scoped=true"
import script from "./TeacherLayout.vue?vue&type=script&lang=js"
export * from "./TeacherLayout.vue?vue&type=script&lang=js"

import "./TeacherLayout.vue?vue&type=style&index=0&id=44b145b2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44b145b2"]])

export default __exports__